import React, { useState, useEffect, useCallback } from "react";
import ProfitHeaderReport from "../components/profitHeaderReport";
import PaginationFooter from "../../../components/footer/paginationFooter";
import ProfitData from "../components/profitData";
import ModalDetailPharmacySales from "../../sales/page/pharmacy_sales/component/modalDetailPharmacySales";
import { useNavigate } from "react-router-dom";
import { formatDateTransaction } from "../../../helper/formatDate";
import { Constant } from "../../../helper/constant";
import ProfitSummary from "../components/profitSummary";

const ProfitReport = () => {
  // =====================
  // Constant Definition
  // =====================
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [filterData, setFilterData] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [transactionData, setTransactionData] = useState([]);
  const [period, setPeriod] = useState("");
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [summaryTransaction, setSummaryTransaction] = useState(null);
  const [isShowDetailTransactionModal, setIsShowDetailTransactionModal] =
    useState(false);
  const [totalTransactionProfit, setTotalTransactionProfit] = useState(0);

  // =====================
  // Method
  // =====================

  const onSearchButtonCliked = (startDate, endDate) => {
    setFilterData({
      start_date: startDate,
      end_date: endDate,
    });
  };

  const onOpenDetailTransaction = (transactionData) => {
    setSelectedTransaction(transactionData);
    setIsShowDetailTransactionModal(true);
  };

  const onCloseModalDetailTransaction = () => {
    setIsShowDetailTransactionModal(false);
    setSelectedTransaction(null);
  };

  const onNextPageClicked = () => {
    if (page < totalPage) {
      setPage((prevPage) => {
        return prevPage + 1;
      });
    }
  };

  const onPreviousPageClicked = () => {
    if (page !== 1) {
      setPage((prevPage) => {
        return prevPage - 1;
      });
    }
  };

  // =====================
  // Network
  // =====================

  const getPharmacyProfit = useCallback(async () => {
    try {
      setIsLoading(true);

      const params = new URLSearchParams({
        start_date: formatDateTransaction(filterData.start_date, "daily"),
        end_date: formatDateTransaction(filterData.end_date, "daily"),
        page: page,
      }).toString();

      const url = `${Constant.BASE_API_URL}/produk-transaksi/profit-pharmacy?${params}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "bearer " + localStorage.getItem("token"),
        },
      });

      if (!response.ok) {
        alert("Gagal Menerima Data");
        if (response.status === 401 || response.status === 403) {
          localStorage.clear();
          return navigate("/login", { replace: true });
        }
      }

      const json = await response.json();
      const data = json.data;

      if (!data.transactions) {
        setTransactionData([]);
      } else {
        setTransactionData(data.transactions);
        setSummaryTransaction(data.summary);
        setPeriod(data.period);
        setTotalTransactionProfit(data.total_transaction_profit);
      }
      setTotalPage(data.total_pages);
    } catch (error) {
      setTransactionData([]);
      setSummaryTransaction(null);
    } finally {
      setIsLoading(false);
    }
  }, [navigate, filterData, page]);

  // =====================
  // UseEffect Hook
  // =====================

  useEffect(() => {
    getPharmacyProfit();
  }, [getPharmacyProfit]);

  return isLoading ? (
    <div className="loading-container">
      <div className="loader"></div>
      <p>Sedang Memuat Mohon Menunggu</p>
    </div>
  ) : (
    <div>
      <h1>Laporan Profit</h1>
      <ProfitHeaderReport onSearchButtonCliked={onSearchButtonCliked} />
      <ProfitData
        period={period}
        transactionData={transactionData}
        onOpenDetailTransaction={onOpenDetailTransaction}
      />
      <PaginationFooter
        isPreviousActive={page > 1}
        isNextActive={page < totalPage}
        onNextClick={onNextPageClicked}
        onPrevClick={onPreviousPageClicked}
      />
      {summaryTransaction != null && (
        <ProfitSummary
          summaryData={summaryTransaction}
          total_transaction_profit={totalTransactionProfit}
        />
      )}

      <ModalDetailPharmacySales
        isShowModal={isShowDetailTransactionModal}
        pharmacyTransaction={selectedTransaction}
        onCloseModal={onCloseModalDetailTransaction}
      />
    </div>
  );
};

export default ProfitReport;
